import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { FeatureFlagActiveDirective } from './directive/feature-flag-active.directive';
import { KillSwitchActiveDirective } from './directive/kill-switch-active.directive';
import { FeatureFlagActiveGuard } from './guard/feature-flag-active.guard';
import { KillSwitchActiveGuard } from './guard/kill-switch-active.guard';
import { FeatureFlagsService } from './service/feature-flags.service';
import { DataAccessTogglesEffects } from './states/toggles/data-access-toggles.effects';
import { DataAccessTogglesFacade } from './states/toggles/data-access-toggles.facade';
import * as fromToggles from './states/toggles/data-access-toggles.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromToggles.DATA_ACCESS_TOGGLES_FEATURE_KEY, fromToggles.togglesReducer),
    EffectsModule.forFeature([DataAccessTogglesEffects]),
  ],
  exports: [FeatureFlagActiveDirective, KillSwitchActiveDirective],
  providers: [FeatureFlagsService, DataAccessTogglesFacade, FeatureFlagActiveGuard, KillSwitchActiveGuard],
  declarations: [FeatureFlagActiveDirective, KillSwitchActiveDirective],
})
export class SharedUtilFeatureFlagsModule {}
